import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { ProgramDropdown} from "CommonDropdowns";
import { map } from "lodash";

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // const [show, setShow] = useState(false); // No longer needed
  const [programValue, setProgramValue] = useState([]);
  const [userValue, setUserValue] = useState([]);



  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    setProgramValue([]);
    setUserValue([]);
  };

  const handleSearch = () => {
    onFilter();
  };



  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programIds = map(selected, 'value');
    setExtraFiltersState((prev) => ({
      ...prev,
      values: { ...prev.values, program_id: programIds },
    }));
  };


  return (
    <div className="filters-flex">
        <Row className="align-items-end">
          <Col lg={8}>
            <ProgramDropdown
              selectedId={extraFiltersState.values.program_id}
              programOnChange={handleProgramChange}
              programValue={programValue}
              setProgramValue={setProgramValue}
              isMulti={true}
            />
          </Col>
          <Col lg={4}>
              <div className="d-flex align-items-end gap-2 mb-3">
                <button
                  type="button"
                  onClick={handleSearch}
                  className="add-new-btn"
                  style={{ minWidth: 100 }}
                >
                  <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
                </button>
                <button
                  type="button"
                  onClick={handleClear}
                  className="btn btn-secondary"
                  style={{ minWidth: 80 }}
                >
                  Clear
                </button>
              </div>
          </Col>
        </Row>
       
        
    </div>
  );
};

export default Filter;
